import { render, staticRenderFns } from "./level_two.vue?vue&type=template&id=a3327de6&scoped=true&"
import script from "./level_two.vue?vue&type=script&lang=js&"
export * from "./level_two.vue?vue&type=script&lang=js&"
import style0 from "./level_two.vue?vue&type=style&index=0&id=a3327de6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3327de6",
  null
  
)

export default component.exports